import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const EnterpriseMsmeTable = () => {

  const pid = useSelector((state) => state.user.projectId);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchData = async () => {

      try {
        setLoading(true);

        const res = await fetch(
          `https://api-project360-insights.haqdarshak.com/kpi/msme/enterprise-msme/?pid=${pid}`
        );

        const result = await res.json();

        setData(result);

      } catch (err) {
        console.error("Error fetching MSME data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (pid) fetchData();

  }, [pid]);

  // 🔢 Totals calculation
  const totals = data.reduce(
    (acc, row) => {
      acc.total_entreprenuers += row.total_entreprenuers || 0;
      acc.edp_Count += row.edp_Count || 0;
      acc.yc_msme_Count += row.yc_msme_Count || 0;
      acc.schemes_msme_Count += row.schemes_msme_Count || 0;
      return acc;
    },
    {
      total_entreprenuers: 0,
      edp_Count: 0,
      yc_msme_Count: 0,
      schemes_msme_Count: 0,
    }
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin h-10 w-10 border-t-2 border-b-2 border-blue-500 rounded-full"></div>
      </div>
    );
  }

  return (
    <div className="bg-white w-[90vw] ml-[4vw] rounded-xl shadow border border-gray-100 p-4">

      <h2 className="text-lg font-semibold mb-4">
        Entrepreneur/MSME Summary
      </h2>

      <div className="overflow-x-auto">

        <table className="min-w-full border border-gray-200 rounded-lg">

          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 border-r text-left text-xs font-medium text-gray-600">State</th>
              <th className="p-3 border-r text-left text-xs font-medium text-gray-600">Total Entrepreneurs</th>
              <th className="p-3 border-r text-left text-xs font-medium text-gray-600">Total EDP Done</th>
              <th className="p-3 border-r text-left text-xs font-medium text-gray-600">MSME YC</th>
              <th className="p-3 text-left text-xs font-medium text-gray-600">MSME Schemes</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-200">

            {data.map((row, idx) => (
              <tr key={idx} className="hover:bg-gray-50">

                <td className="p-3 border-r text-sm">{row.State}</td>

                <td className="p-3 border-r text-sm">
                  {row.total_entreprenuers?.toLocaleString()}
                </td>

                <td className="p-3 border-r text-sm">
                  {row.edp_Count?.toLocaleString()}
                </td>

                <td className="p-3 border-r text-sm">
                  {row.yc_msme_Count?.toLocaleString()}
                </td>

                <td className="p-3 text-sm">
                  {row.schemes_msme_Count?.toLocaleString()}
                </td>

              </tr>
            ))}

            {/* 🔹 TOTAL ROW */}
            <tr className="bg-gray-100 font-semibold">

              <td className="p-3 border-r">Total</td>

              <td className="p-3 border-r">
                {totals.total_entreprenuers.toLocaleString()}
              </td>

              <td className="p-3 border-r">
                {totals.edp_Count.toLocaleString()}
              </td>

              <td className="p-3 border-r">
                {totals.yc_msme_Count.toLocaleString()}
              </td>

              <td className="p-3">
                {totals.schemes_msme_Count.toLocaleString()}
              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default EnterpriseMsmeTable;